<template>
  <div style="width:100%;">
    <back />
    <div style="padding:10px;margin-bottom:50px;">
      <div class="addressInfo whiteBg">
        <div class="flex senderInfo bbm">
          <div class="img flex">
            <div class="icon flex">寄</div>
          </div>
          <div class="senderDetails" @click="toSenderInfo()">
            <div class="namePhone" style="font-weight:700;">
              {{
                senderInfo.myName
                  ? senderInfo.myName + ' ' + senderInfo.phone
                  : '寄件人信息'
              }}
            </div>
            <div class="address-detail font-13">
              {{
                senderInfo.address
                  ? senderInfo.province +
                    senderInfo.city +
                    senderInfo.district +
                    senderInfo.address
                  : '点击填写寄件人信息'
              }}
            </div>
          </div>
          <div class="addressBook" @click="toSenderBook()">地址簿</div>
        </div>
        <div class="flex senderInfo">
          <div class="img flex">
            <div class="icon flex" style="background-color:#a30015">收</div>
          </div>
          <div class="senderDetails" @click="toAddresseeInfo()">
            <div class="namePhone" style="font-weight:700;">
              {{
                addresseeInfo.myName
                  ? addresseeInfo.myName + ' ' + addresseeInfo.phone
                  : '收件人信息'
              }}
            </div>
            <div class="address-detail font-13">
              {{
                addresseeInfo.address
                  ? addresseeInfo.province +
                    addresseeInfo.city +
                    addresseeInfo.district +
                    addresseeInfo.address
                  : '点击填写收件人信息'
              }}
            </div>
          </div>
          <div class="addressBook" @click="toAddresseeBook()">地址簿</div>
        </div>
      </div>
      <div class="listItem whiteBg" v-if="!senderInfo.realnameFlag">
        <span>实名认证</span>
        <div class="cerRight" @click="toCertification()">
          <span class="text">根据规定，寄件须实名认证</span>
          <i class="arrowIcon">
            <van-icon name="arrow" size="18" />
          </i>
        </div>
      </div>
      <div class="infoDetails whiteBg">
        <!-- <div class="infoTop flex">
          <span>寄件方式</span>
          <div class="modeBtn">
            <van-button
              plain
              round
              :color="selectedType === 0 ? '#a30015' : '#000'"
              class="btn"
              @click="selectedType = 0"
              >快递柜</van-button
            >
            <van-button
              plain
              round
              :color="selectedType === 1 ? '#a30015' : '#000'"
              class="btn"
              @click="selectedType = 1"
              >服务网点</van-button
            >
          </div>
        </div>
        <div v-if="selectedType === 0">
          <div
            class="adInfo"
            v-for="(item, index) in glist"
            :key="index"
            :style="index == selectedAddress ? 'border-color:#a30015' : ''"
            @click="selectedAddress = index"
          >
            <div class="infoTitle">
              <div class="type">
                {{ item.type }}
              </div>
              <div class="title">{{ item.title }}</div>
              <div class="text">16m</div>
            </div>
            <div class="support" v-if="item.type === '快递柜'">
              支持寄件：顺丰、申通、圆通
            </div>
            <div class="support" v-if="item.type === '快递柜'">
              可用格口：小丨中丨大
            </div>
            <div class="selected flex" v-show="index == selectedAddress">
              <img src="@/../static/icon-hook.svg" alt="" />
            </div>
          </div>
        </div>
        <div v-if="selectedType === 1">
          <div
            class="adInfo"
            v-for="(item, index) in ylist"
            :key="index"
            :style="index == selectedAddress ? 'border-color:#a30015' : ''"
            @click="selectedAddress = index"
          >
            <div class="infoTitle">
              <div class="type">
                {{ item.type }}
              </div>
              <div class="title">{{ item.title }}</div>
              <div class="text">16m</div>
            </div>
            <div class="support" v-if="item.type === '驿站'">
              详细地址：{{ item.address }}
            </div>
            <div class="support" v-if="item.type === '驿站'">
              营业时间：{{ item.time }}
            </div>
            <div class="selected flex" v-show="index == selectedAddress">
              <img src="@/../static/icon-hook.svg" alt="" />
            </div>
          </div>
        </div> -->
        <div class="infoTop flex">
          <span>寄件方式</span>
          <div class="modeBtn">
            <van-button
              plain
              round
              color="#a30015"
              class="btn"
              @click="selectedType = 1"
              >服务网点</van-button
            >
          </div>
        </div>
        <div>
          <div
            class="adInfo"
            v-for="(item, index) in ylist"
            :key="index"
            :style="index == selectedAddress ? 'border-color:#a30015' : ''"
            @click="changeAddress(index)"
          >
            <div class="infoTitle">
              <div class="type" style="min-width: 32px;">
                驿站
              </div>
              <div class="title">{{ item.siteName }}</div>
              <div class="text">{{ item.dis | formatDis }}</div>
            </div>
            <div class="support">详细地址：{{ item.siteAddress }}</div>
            <div class="support">
              营业时间：{{ item.siteOpenTime + '~' + item.siteCloseTime }}
            </div>
            <div class="selected flex" v-show="index == selectedAddress">
              <img src="@/../static/icon-hook.svg" alt="" />
            </div>
          </div>
        </div>
        <!-- <div class="flex">{{ latitude + ',' + longitude }}</div> -->
        <div class="flex font-14 empty" v-if="ylist.length === 0">
          当前位置附近暂无服务网点
          <van-icon name="replay" size="18" @click="getPostStageList()" />
        </div>
        <div
          class="flex bbm"
          style="padding:10px;font-size:14px"
          @click="toAllServicePoint()"
        >
          <span>查看全部 ></span>
        </div>
        <div class="listItem whiteBg bbm">
          <span>物品信息</span>
          <div class="cerRight" @click="handleGoodsMsg()">
            <span class="text">{{ goodsInfo || '请选择' }}</span>
            <div class="flex">
              <van-icon name="arrow" size="18" />
            </div>
          </div>
        </div>
        <goods-message ref="goodsMsg" @getMsg="handleMsg" />
        <div class="listItem whiteBg">
          <span>快递选择</span>
          <div class="cerRight" @click="handleChooseExpress()">
            <!-- <span class="text">{{
              selectedExpress == {} ? selectedExpress.name : '请选择'
            }}</span> -->
            <span class="text">{{
              selectedExpress.companyName || '请选择'
            }}</span>
            <div class="flex">
              <van-icon name="arrow" size="18" />
            </div>
          </div>
        </div>
      </div>
      <div class="listItem whiteBg" style="margin:10px 0 20px 0">
        <span style="white-space:nowrap;">备注（非必填）</span>
        <div class="cerRight" @click="handleRemark()">
          <span class="text nowarp">{{ remarkInfo || '请添加备注' }}</span>
          <div class="flex">
            <van-icon name="arrow" size="18" />
          </div>
        </div>
      </div>
      <remarks ref="remark" @getRemark="handleReInfo" />
    </div>
    <div class="footer whiteBg flex">
      <van-button class="placeOrder flex" @click="handleSubmitOrder()"
        >立即下单</van-button
      >
    </div>
  </div>
</template>
<script>
import goodsMessage from './components/goodsMessage'
import remarks from './components/remarks'
import Back from '@/components/back'
// import wx from 'weixin-js-sdk'
export default {
  components: {
    goodsMessage,
    remarks,
    Back
  },
  filters: {
    formatDis(dis) {
      if (dis >= 1000) {
        return (dis / 1000).toFixed(2) + 'km'
      } else {
        return dis + 'm'
      }
    }
  },
  data() {
    return {
      senderInfo: {},
      addresseeInfo: {},
      selectedType: 1,
      selectedAddress: 0,
      selectedExpress: {},
      goodsInfo: '',
      remarkInfo: '',
      ylist: [],
      longitude: 0,
      latitude: 0
    }
  },
  // beforeRouteLeave(to, from, next) {
  //   console.log('销毁')
  //   this.$destroy()
  //   next()
  // },
  created() {
    window.onpageshow = function(event) {
      if (event.persisted) {
        window.location.reload()
      }
    }
    if (localStorage.getItem('location')) {
      let obj = JSON.parse(localStorage.getItem('location'))
      this.longitude = obj.longitude
      this.latitude = obj.latitude
    }
    this.loadingData()
  },
  // beforeDestroy() {
  //   console.log('beforeDestroy')
  //   this.$destroy()
  // },
  mounted() {
    // let that = this
  },
  methods: {
    loadingData() {
      if (this.$store.state.senderInfo) {
        this.senderInfo = this.$store.state.senderInfo
        this.getPostStageList()
      } else {
        this.$api.getSenderDefaultAddress().then(res => {
          if (res.data) {
            this.$store.commit('set_senderInfo', res.data)
            this.senderInfo = this.$store.state.senderInfo
          }
          this.getPostStageList()
        })
      }
      if (this.$store.state.addresseeInfo) {
        this.addresseeInfo = this.$store.state.addresseeInfo
      }
      if (this.$store.state.selectedAddress !== 0) {
        if (this.$store.state.selectedAddress === null) {
          this.selectedAddress = 0
        } else {
          this.selectedAddress = this.$store.state.selectedAddress
        }
      }
      if (this.$store.state.selectedExpress) {
        this.selectedExpress = this.$store.state.selectedExpress
      }
      if (this.$store.state.goodsMessage !== '') {
        this.goodsInfo = this.$store.state.goodsMessage
      }
      if (this.$store.state.remark) {
        this.handleReInfo(this.$store.state.remark)
      }
    },
    toCertification() {
      if (JSON.stringify(this.senderInfo) === '{}') {
        this.$notify('请先填写寄件人信息')
        return
      }
      this.$router.push({
        name: 'certification',
        query: { addressId: this.senderInfo.addressId }
      })
    },
    toSenderInfo() {
      this.$router.push({
        name: 'senderInfo',
        query: { addressId: this.senderInfo.addressId, path: 'go' }
      })
    },
    toSenderBook() {
      this.$router.push({ path: '/senderAddressBook' })
    },
    toAddresseeInfo() {
      this.$router.push({
        name: 'addresseeInfo',
        query: { addressId: this.addresseeInfo.addressId, path: 'go' }
      })
    },
    toAddresseeBook() {
      this.$router.push({ path: '/addresseeAddressBook' })
    },
    toAllServicePoint() {
      this.$router.push({ path: '/allServicePoint' })
    },
    handleGoodsMsg() {
      this.$refs.goodsMsg.handleShow()
    },
    handleRemark() {
      this.$refs.remark.handleShow()
    },
    handleMsg(data) {
      this.goodsInfo = data
      this.$store.commit('set_goodsMessage', data)
      // console.log(data)
    },
    handleReInfo(data) {
      this.remarkInfo = data.type.join()
      if (data.remark !== '') {
        if (data.type.length) {
          this.remarkInfo += ',' + data.remark
        } else {
          this.remarkInfo = data.remark
        }
      }
      this.$store.commit('set_remark', data)
    },
    handleChooseExpress() {
      if (!this.addresseeInfo.provinceCode) {
        this.$notify({
          message: '请先填写收件人信息'
        })
        return
      }
      console.log(this.selectedAddress)
      if (this.ylist[this.selectedAddress].siteId === undefined) {
        this.$notify({
          message: '请先选择服务网点'
        })
        return
      }
      let params = {
        siteId: this.ylist[this.selectedAddress].siteId,
        areaId: this.addresseeInfo.provinceCode
      }
      this.$router.push({ path: '/chooseExpress', query: params })
    },
    getPostStageList() {
      if (localStorage.getItem('location')) {
        let obj = JSON.parse(localStorage.getItem('location'))
        this.longitude = obj.longitude
        this.latitude = obj.latitude
      }
      let params = {
        myLng: this.longitude,
        myLat: this.latitude,
        pageNum: 1,
        pageSize: 10
      }
      console.log(params)
      let data = this.$Base64.encode(JSON.stringify(params))
      this.$api.getPostStageList(data).then(res => {
        // console.log(res)
        if (res.code === 0) {
          this.ylist = res.data.rows.slice(0, 2)
          if (this.$store.state.selectedService) {
            for (let i in this.ylist) {
              if (
                this.ylist[i].siteId ===
                this.$store.state.selectedService.siteId
              ) {
                this.selectedAddress = i
                this.$store.commit('set_selectedAddress', i)
                return
              }
            }
            this.ylist[0] = this.$store.state.selectedService
            this.selectedAddress = 0
            this.$store.commit('set_selectedAddress', 0)
          }
        }
      })
    },
    handleSubmitOrder() {
      let msg = this.isDefine()
      if (msg) {
        this.$notify({
          message: msg,
          type: 'danger',
          duration: 1000
        })
        return
      }
      this.$api.getOrderToken().then(res => {
        let params = {
          siteId: this.ylist[this.selectedAddress].siteId,
          expressCompanyId: this.selectedExpress.expressCompanyId,
          senderAddressId: this.senderInfo.addressId,
          receiverAddressId: this.addresseeInfo.addressId,
          goodsName: this.goodsInfo,
          payType: 0,
          note: this.remarkInfo
        }
        let token = {
          ApiToken: res.data.token
        }
        let data = this.$Base64.encode(JSON.stringify(params))
        this.$api.createOrder(data, token).then(res => {
          if (res.code === 0) {
            this.$toast({
              message: '下单成功！',
              type: 'success',
              duration: 1500,
              forbidClick: true,
              onClose: () => {
                this.$router.replace('/home')
              }
            })
          } else {
            this.$toast({
              message: res.msg,
              type: 'fail',
              duration: 1500,
              forbidClick: true
            })
          }
        })
      })
    },
    isDefine() {
      let msg = ''
      if (!this.senderInfo.addressId) {
        msg = '请填写寄件人信息'
        return msg
      }
      if (!this.addresseeInfo.addressId) {
        msg = '请填写收件人信息'
        return msg
      }
      if (!this.senderInfo.realnameFlag) {
        msg = '寄件须实名认证'
        return msg
      }
      if (!this.ylist.length) {
        msg = '请选择服务网点'
        return msg
      }
      if (!this.goodsInfo) {
        msg = '请填写物品信息'
        return msg
      }
      if (!this.selectedExpress.expressCompanyId) {
        msg = '请选择快递'
        return msg
      }
    },
    changeAddress(index) {
      this.selectedAddress = index
      this.$store.commit(
        'set_selectedService',
        this.ylist[this.selectedAddress]
      )
      this.$store.commit('set_selectedAddress', this.selectedAddress)
      this.selectedExpress = {}
    }
  }
}
</script>
<style lang="scss">
.nowarp {
  width: calc(100vw - 190px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.listItem {
  display: flex;
  padding: 0 5px 0 14px;
  height: 44px;
  font-size: 16px;
  align-items: center;
  .cerRight {
    display: flex;
    flex: 1;
    text-align: right;
  }
  .text {
    // display: flex;
    // align-items: center;
    // justify-content: flex-end;
    color: #7f7f7f;
    flex: 1;
    font-size: 14px;
    margin: 0 10px;
  }
  .arrowIcon {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.addressInfo {
  width: 100%;
  height: 150px;
  margin-bottom: 10px;
  font-size: 15px;
  .img {
    width: 50px;
    height: 75px;
    .icon {
      width: 26px;
      height: 26px;
      background-color: #555;
      color: #fff;
      font-size: 12px;
    }
  }
  .senderInfo {
    .senderDetails {
      display: flex;
      flex-direction: column;
      flex: 1;
      margin: 0 10px;
      height: 75px;
      justify-content: center;
      .namePhone {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
      .address-detail {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
    }
    .addressBook {
      padding: 0 10px;
      width: 46px;
      border-left: 1px solid #ccc;
    }
  }
}

.infoDetails {
  margin-top: 10px;
  .infoTop {
    padding: 0 5px 0 14px;
    height: 44px;
    font-size: 16px;
    .modeBtn {
      display: flex;
      justify-content: flex-end;
      flex: 1;
      .btn {
        margin: 0 5px;
        width: 90px;
        height: 36px;
      }
    }
  }
  .adInfo {
    position: relative;
    margin: 10px;
    padding: 5px;
    border: 1px solid rgb(170, 170, 170);
    border-radius: 5px;
    .infoTitle {
      height: 36px;
      display: flex;
      align-items: center;
      font-size: 14px;
      .type {
        // width: 44px;
        height: 16px;
        padding: 4px;
        color: #fff;
        font-size: 12px;
        text-align: center;
        line-height: 16px;
        border-radius: 6px;
        background-color: #000;
      }
      .title {
        padding: 0 10px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .text {
        flex: 1;
        padding: 0 10px;
        border-left: 1px solid #ccc;
      }
    }
    .support {
      padding: 2px 0;
      width: calc(100% - 40px);
      font-size: 12px;
      color: #7f7f7f;
    }
    .selected {
      position: absolute;
      top: 0;
      right: 0;
      width: 24px;
      height: 24px;
      border-radius: 0 5px;
      background-color: #a30015;
      color: #fff;
    }
  }
}
.footer {
  position: fixed;
  width: 100%;
  bottom: 0px;
  height: 54px;
  .placeOrder {
    width: calc(100% - 20px);
    height: 44px;
    border-radius: 22px;
    color: #fff;
    background-color: #a30014;
  }
}
.empty {
  height: 60px;
  margin: 5px 10px;
  background-color: #f4f4f4;
  color: #555;
}
</style>
